import { splitProps } from "solid-js"
import * as SeparatorPrimitive from "@kobalte/core/separator"
import { cn } from "~/lib/utils"

const Separator = (props) => {
  const [local, others] = splitProps(props, ["class", "orientation"])
  return (
    <SeparatorPrimitive.Root
      data-slot="separator"
      orientation={local.orientation ?? "horizontal"}
      class={cn(
        "shrink-0 bg-border data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px",
        local.class
      )}
      {...others}
    />
  )
}

export { Separator }
